import { setsToWin } from '@/lib/match-format';
import type { Match, MatchFormat } from '@/data/types';

interface Props {
  match: Match;
  format: MatchFormat;
  onPick: (winnerId: string, aSets: number, bSets: number) => void;
  disabled?: boolean;
}

export function ScoreBySummary({ match, format, onPick, disabled }: Props) {
  const need = setsToWin(format);
  // Доступные итоги: (need:0), (need:1), ... (need:need-1) для каждого победителя
  const aResults: Array<[number, number]> = [];
  const bResults: Array<[number, number]> = [];
  for (let losses = 0; losses < need; losses++) {
    aResults.push([need, losses]);
    bResults.push([losses, need]);
  }

  if (!match.playerAId || !match.playerBId) {
    return <p className="t-small t-mute">Не оба игрока определены.</p>;
  }

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div>
        <div className="t-eyebrow" style={{ marginBottom: 8 }}>
          Победил {match.playerAName}
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${need}, 1fr)`,
            gap: 8,
          }}
        >
          {aResults.map(([a, b]) => (
            <button
              key={`a-${a}-${b}`}
              className="score-btn"
              disabled={disabled}
              onClick={() => onPick(match.playerAId!, a, b)}
            >
              <span className="score">
                {a}:{b}
              </span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <div className="t-eyebrow" style={{ marginBottom: 8 }}>
          Победил {match.playerBName}
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${need}, 1fr)`,
            gap: 8,
          }}
        >
          {bResults.map(([a, b]) => (
            <button
              key={`b-${a}-${b}`}
              className="score-btn"
              disabled={disabled}
              onClick={() => onPick(match.playerBId!, a, b)}
            >
              <span className="score">
                {a}:{b}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
